import { toast as sonnerToast } from "sonner";

interface ToastOptions {
	title: string;
	description?: string;
	color?: "primary" | "secondary" | "success" | "warning" | "danger";
	duration?: number;
}

export function addToast({
	title,
	description,
	color,
	duration,
}: ToastOptions) {
	switch (color) {
		case "danger":
			return sonnerToast.error(title, {
				description,
				duration,
			});
		case "warning":
			return sonnerToast.warning(title, {
				description,
				duration,
			});
		case "success":
			return sonnerToast.success(title, {
				description,
				duration,
			});
		case "primary":
		case "secondary":
		default:
			return sonnerToast(title, {
				description,
				duration,
			});
	}
}

export const toast = {
	success: (title: string, description?: string, duration?: number) =>
		addToast({ title, description, color: "success", duration }),
	error: (title: string, description?: string, duration?: number) =>
		addToast({ title, description, color: "danger", duration }),
	warning: (title: string, description?: string, duration?: number) =>
		addToast({ title, description, color: "warning", duration }),
	info: (title: string, description?: string, duration?: number) =>
		addToast({ title, description, duration }),
};
